import { render, staticRenderFns } from "./ProduceExp.vue?vue&type=template&id=173154e1&scoped=true&"
import script from "./ProduceExp.vue?vue&type=script&lang=ts&"
export * from "./ProduceExp.vue?vue&type=script&lang=ts&"
import style0 from "./ProduceExp.vue?vue&type=style&index=0&id=173154e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173154e1",
  null
  
)

export default component.exports